'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createReactClass2.default)({

    displayName: 'GoogleMaps.Map',

    getDefaultProps: function getDefaultProps() {
        return {
            styles: [],
            googleMapsOptions: {}
        };
    },
    closeInfoWindows: function closeInfoWindows() {
        _lodash2.default.each(this.infoWindows, function (w) {
            return w.close();
        });
    },
    componentDidMount: function componentDidMount() {
        var _this = this;

        this.children = [];
        this.infoWindows = [];
        this.map = new google.maps.Map(_reactDom2.default.findDOMNode(this), _lodash2.default.extend({
            center: this.props.center,
            zoom: this.props.zoom,
            disableDefaultUI: this.props.disableDefaultUI,
            styles: this.props.styles,
            fullscreenControl: false
        }, this.props.googleMapsOptions));

        if (this.props.showRoute) {
            // setting up google direction service to show routes if needed
            this.directionsService = new google.maps.DirectionsService();
            this.directionsDisplay = new google.maps.DirectionsRenderer({
                suppressMarkers: true,
                polylineOptions: {
                    strokeOpacity: 0,
                    fillOpacity: 0,
                    strokeColor: '#e05050',
                    icons: [{
                        icon: {
                            path: 'M0 0 h1 v1.5 h-1 z',
                            strokeOpacity: 1,
                            scale: 2
                        },
                        offset: '0',
                        repeat: '8px'
                    }]
                }
            });
            this.directionsDisplay.setMap(this.map);
        }

        this.componentDidUpdate();

        if (typeof MutationObserver !== 'undefined') {
            this.observer = new MutationObserver(function () {
                if (_this.isMounted()) {
                    google.maps.event.trigger(_this.map, 'resize');
                    _this.observer.disconnect();
                }
            });
            var config = { attributes: true, childList: true, characterData: true };
            this.observer.observe(document.body, config);
        }

        google.maps.event.addListenerOnce(this.map, 'tilesloaded', function () {
            _this.center = null;
            _this.zoom = null;
            _this.panTo = null;
            _this.panToBounds = null;

            _this.componentDidUpdate();
        });

        this.map.addListener('click', this.props.onClick);
    },
    componentWillUnmount: function componentWillUnmount() {
        this.observer && this.observer.disconnect();
    },
    onLocaleChange: function onLocaleChange() {
        this.map = new google.maps.Map(_reactDom2.default.findDOMNode(this), {
            center: this.props.center,
            zoom: this.props.zoom,
            disableDefaultUI: this.props.disableDefaultUI
        });
        this.componentDidUpdate();
    },
    componentWillUpdate: function componentWillUpdate(nextProps) {
        if (this.props.locale !== nextProps.locale) {
            this.onLocaleChange();
        }
    },
    componentDidUpdate: function componentDidUpdate() {
        var _this2 = this;

        var nextProps = this.props;

        var newChildren = [];
        _react2.default.Children.forEach(this.props.children, function (child) {
            if (child && !findChildInPrevChildren(child, _this2.children)) {
                newChildren.push(child);
            }
        });

        this.children = _lodash2.default.reject(this.children, function (prevChild) {
            if (!findChildInNewChildren(prevChild, _this2.props.children)) {
                prevChild.obj.setMap(null);
                return true;
            }
            return false;
        });

        // Reposition every parameter according to the following logice if
        //      1. There is a new paremeter
        //      And
        //      2. One of the following:
        //          2.1. Parameter is different from previous set parameter
        //          2.2. this.props.forceBounds is boolean true
        //          2.3. this.props.forceBounds doesn't equal to previous value, but is not false
        if (shouldUpdateBoundParam(nextProps.center, this.center, nextProps.forceBounds, this.forceBounds)) {
            this.map.setCenter(new google.maps.LatLng(nextProps.center.lat, nextProps.center.lng));
        }
        this.center = nextProps.center;

        if (shouldUpdateBoundParam(nextProps.zoom, this.zoom, nextProps.forceBounds, this.forceBounds)) {
            this.map.setZoom(nextProps.zoom);
        }
        this.zoom = nextProps.zoom;

        if (shouldUpdateBoundParam(nextProps.panTo, this.panTo, nextProps.forceBounds, this.forceBounds)) {
            this.map.panTo(new google.maps.LatLng(nextProps.panTo.lat, nextProps.panTo.lng));

            if (nextProps.panOffset) this.map.panBy(nextProps.panOffset.x || 0, nextProps.panOffset.y || 0);
        }
        this.panTo = nextProps.panTo;

        if (shouldUpdateBoundParam(nextProps.panToBounds, this.panToBounds, nextProps.forceBounds, this.forceBounds)) {
            var bounds = new google.maps.LatLngBounds();
            _lodash2.default.each(nextProps.panToBounds, function (point) {
                bounds.extend(new google.maps.LatLng(point.lat, point.lng));
            });
            this.map.panToBounds(bounds);
        }

        if (shouldUpdateBoundParam(nextProps.fitBounds, this.fitBounds)) {
            this.fitBounds = nextProps.fitBounds;
            var _bounds = new google.maps.LatLngBounds();
            _lodash2.default.each(nextProps.fitBounds, function (point) {
                _bounds.extend(new google.maps.LatLng(point.lat, point.lng));
            });
            this.map.fitBounds(_bounds);

            if (nextProps.fitBoundsOffset) this.map.panBy(nextProps.fitBoundsOffset.x, nextProps.fitBoundsOffset.y);
        }

        this.panToBounds = nextProps.panToBounds;
        this.forceBounds = nextProps.forceBounds;

        var requestRoute = {
            origin: null,
            destination: null,
            travelMode: 'DRIVING'
        };

        // Draw any new children (polygons or markers)
        _react2.default.Children.forEach(newChildren, function (child) {
            if (!child) return;
            if (child.type.displayName === 'GoogleMaps.Marker') {

                // IE11 crashes the app when using a custom icon marker
                //
                var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

                // We don't care which marker is the source and which is the destination, we only want to show the route between them.
                if (requestRoute.origin) {
                    requestRoute.destination = new google.maps.LatLng(child.props.position.lat, child.props.position.lng);
                } else {
                    requestRoute.origin = new google.maps.LatLng(child.props.position.lat, child.props.position.lng);
                }

                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(child.props.position.lat, child.props.position.lng),
                    map: _this2.map,
                    label: child.props.label,
                    icon: isIE11 ? undefined : child.props.icon,
                    draggable: !!child.props.draggable
                });

                if (child.props.draggable) {
                    marker.addListener('mouseup', function () {
                        _lodash2.default.get(child, 'props.onDragEnd', _lodash2.default.noop)({
                            position: marker.position.toJSON()
                        });
                    });
                }

                if (child.props.animated) {
                    marker.addListener('mousedown', function () {
                        marker.setAnimation(google.maps.Animation.Uo);
                    });

                    marker.addListener('mouseup', function () {
                        if (marker.getAnimation() !== null) {
                            marker.setAnimation(null);
                        } else {
                            marker.setAnimation(google.maps.Animation.So);
                        }
                    });
                }

                _this2.children.push({ obj: marker, type: child.type.displayName, props: _lodash2.default.clone(child.props) });
                if (child.props.onClick) marker.addListener('click', child.props.onClick);

                if (child.props.dangerousInfoWindow) {
                    var infowindow;

                    if (child.props.infobox) {
                        //Depends on window.google, which might not be available
                        //upon the module's init phase. Causes the BM to crash
                        //in some instances (Ukraine language)
                        var InfoBox = require('google-maps-infobox');

                        infowindow = new InfoBox({
                            content: child.props.dangerousInfoWindow
                        });
                    } else infowindow = new google.maps.InfoWindow({ content: child.props.dangerousInfoWindow });

                    _this2.infoWindows.push(infowindow);

                    marker.addListener('click', function () {
                        _this2.closeInfoWindows();
                        infowindow.open(_this2.map, marker);
                    });

                    if (child.props.autoOpenTooltip) {
                        _this2.closeInfoWindows();
                        infowindow.open(_this2.map, marker);
                    }

                    child.props.closeInfoWindowOnBlur && _this2.map.addListener('click', _this2.closeInfoWindows);
                }
            } else if (child.type.displayName === 'GoogleMaps.Polygon') {
                var polygon = new google.maps.Polygon({
                    paths: child.props.paths,
                    strokeColor: child.props.strokeColor,
                    strokeOpacity: child.props.strokeOpacity,
                    strokeWeight: child.props.strokeWeight,
                    fillColor: child.props.fillColor,
                    fillOpacity: child.props.fillOpacity,
                    geodesic: child.props.geodesic,
                    draggable: child.props.draggable,
                    editable: child.props.editable,
                    map: _this2.map
                });
                if (child.props.onClick) polygon.addListener('click', child.props.onClick);
                if (child.props.onMouseOver) polygon.addListener('mouseover', child.props.onMouseOver);
                if (child.props.onMouseOut) polygon.addListener('mouseout', child.props.onMouseOut);
                if (child.props.onRightClick) polygon.addListener('rightclick', child.props.onRightClick);
                if (child.props.onMouseUp) polygon.addListener('mouseup', function (e) {
                    child.props.onMouseUp(e, polygon);
                });

                _this2.children.push({ obj: polygon, type: child.type.displayName, props: _lodash2.default.clone(child.props) });
            }
        });

        if (this.props.showRoute && requestRoute.origin && requestRoute.destination) {
            this.directionsService.route(requestRoute, function (result, status) {
                if (status === 'OK') {
                    _this2.directionsDisplay.setDirections(result);
                } else {
                    console.error("Request Route: status=", status, "result=", result);
                }
            });
        }

        try {
            google.maps.event.trigger(this.map, 'resize');
        } catch (err) {
            console.error('GoogleMaps/Map.js', err);
        }

        return false; // Update is done programmatically and not by calling render again
    },
    render: function render() {
        return _react2.default.createElement('div', { className: this.props.className, style: this.props.style });
    },
    getMapNode: function getMapNode() {
        return this.map;
    }
});


function findChildInPrevChildren(child, prevChildren) {
    return !!_lodash2.default.find(prevChildren, function (prevChild) {
        return isSameChild(prevChild, child);
    });
}

function findChildInNewChildren(prevChild, newChildren) {
    var ret = false;
    _react2.default.Children.forEach(newChildren, function (child) {
        if (!child) return;
        ret = ret || isSameChild(prevChild, child);
    });
    return ret;
}

function isSameChild(existingChild, newChild) {
    if (existingChild.type !== newChild.type.displayName) return false;
    if (!_lodash2.default.isEqual(_lodash2.default.keys(existingChild.props), _lodash2.default.keys(newChild.props))) return false;
    return _lodash2.default.every(existingChild.props, function (v, k) {
        return _lodash2.default.isEqual(existingChild.props[k], newChild.props[k]);
    });
}

function shouldUpdateBoundParam(currentValue, prevValue, currentForceBounds, previousForceBounds) {
    if (_lodash2.default.isUndefined(currentValue) || _lodash2.default.isNull(currentValue)) return false;
    if (!_lodash2.default.isEqual(currentValue, prevValue)) return true;
    if (currentForceBounds === true) return true;
    if (currentForceBounds === false) return false;
    if (currentForceBounds !== previousForceBounds) return true;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-components/dist/web/GoogleMaps/Map.js
// module id = 1156
// module chunks = 0